export interface IContactChannels {
  type: number;
  name?: string;
  data: string;
  icon?: any;
}

export enum enContactChannelsType {
  whatsApp = 0,
  telegram = 1,
  email = 2,
  studyGroup = 3,
  warningGroup = 4,
  genericLink = 5
}